module.exports = __webpack_public_path__ + "media/images/area/feature/kansai/related/th/2-0335559aa1a9bcf8a6ab7cc69a2e28d4.jpg";